import React, {useEffect, useState} from "react";
import {NewVariationWrap} from "components/atoms/MenuManagement/AddVariation/AddAvriation.styles";
import Form from "components/molecules/Form/Form";
import Field from "components/molecules/Field";
import {useForm} from "components/molecules/Form";
import Button from "components/molecules/Button";
import {FaPlus} from "react-icons/fa";
import {MdDelete} from "react-icons/md";
import AddSubVariation from "../SubVariation";
import ModalContainer from "components/molecules/ModalContainer";

const AddVariation = ({onClose, setVariations, variationsData, isEdit}) => {
    const [form] = useForm();

    // each variation entry now includes subVariations array
    const [formState, setFormState] = useState([{variationName: "", price: "", calories: "", subVariations: []}]);

    useEffect(() => {
        if (isEdit && variationsData) {
            const updatedState = variationsData.map(item => ({
                variationName: item.variationName || "",
                price: item.price || "",
                calories: item.calories || "",
                subVariations: item.subVariations || []
            }));
            setFormState(updatedState);

            const fieldValues = updatedState
                .map((item, ind) => ({
                    [`variationName${ind}`]: item.variationName || "",
                    [`price${ind}`]: item.price || "",
                    [`calories${ind}`]: item.calories || ""
                }))
                .reduce((acc, curr) => ({...acc, ...curr}), {});

            form.setFieldsValue(fieldValues);
        }
    }, [isEdit, variationsData, form]);

    const handleSubmit = () => {
        // keep your original behavior: save all variations (now including subVariations)
        setVariations(formState);
        onClose();
    };

    const addFeilds = () => {
        setFormState(prevState => [...prevState, {variationName: "", price: "", calories: "", subVariations: []}]);
    };

    const handleFieldChange = (index, field, value) => {
        setFormState(prevState => prevState.map((item, i) => (i === index ? {...item, [field]: value} : item)));
        form.setFieldsValue({[`${field}${index}`]: value});
    };

    const removeVariation = index => {
        setFormState(prevState => prevState.filter((_, i) => i !== index));
    };

    // called when AddSubVariation saves results for a specific variation
    const handleSaveSubVariations = (index, subVars) => {
        setFormState(prev => {
            const copy = [...prev];
            copy[index] = {...copy[index], subVariations: subVars};
            return copy;
        });
    };

    return (
        <>
            <NewVariationWrap>
                <div className="heading">
                    <strong>Variations</strong>
                    <p>Add a variation of this item comes in sizes (e.g. Small, Medium, Large).</p>
                </div>
                <Form form={form} onSubmit={() => handleSubmit()} className="form-wrap">
                    {formState.map((item, ind) => (
                        <div key={ind}>
                           <div className="delete-btn">
                                <Button danger sm type="button" onClick={() => removeVariation(ind)}>
                                    <MdDelete />
                                    Delete
                                </Button>
                            </div>
                            <div className="user-fields">
                                <Form.Item
                                    label="Variation Name *"
                                    type="text"
                                    name={`variationName${ind}`}
                                    lg
                                    placeholder="Regular"
                                    $bgWhite
                                    value={item.variationName}
                                    onChange={e => handleFieldChange(ind, "variationName", e.target.value)}
                                    rules={[{required: true, message: "Name is required"}]}>
                                    <Field />
                                </Form.Item>

                                <Form.Item
                                    label="Enter Price *"
                                    type="number"
                                    min={0}
                                    step="any"
                                    name={`price${ind}`}
                                    lg
                                    placeholder="$5"
                                    $bgWhite
                                    value={item.price}
                                    onChange={e => handleFieldChange(ind, "price", e.target.value)}
                                    rules={[{required: true, message: "Price is required"}]}>
                                    <Field />
                                </Form.Item>
                            </div>
                                <Form.Item
                                    label="Calories (per serving)"
                                    type="number"
                                    min={0}
                                    step="any"
                                    name={`calories${ind}`}
                                    lg
                                    placeholder="e.g., 250 or 23.5"
                                    $bgWhite
                                    value={item.calories}
                                    onChange={e => handleFieldChange(ind, "calories", e.target.value)}
                                    rules={[{required: true, message: "Calories is required"}]}>
                                    <Field suffix="kcal" />
                                </Form.Item>

                                <ModalContainer
                                    width={850}
                                    noBorder
                                    title="Add Sub Variation Group"
                                    btnComponent={({onClick}) => (
                                        <p className="sub-variation-btn" onClick={onClick}>+ Add Sub Variation Group</p>
                                    )}
                                    content={({onClose}) => (
                                        <AddSubVariation
                                            isEdit={true}
                                            initialSubVariations={item.subVariations || []}
                                            onSave={(subVars) => {
                                                handleSaveSubVariations(ind, subVars);
                                                onClose();
                                            }}
                                            onClose={onClose}
                                        />
                                    )}
                                />
                        </div>
                    ))}

                    <div className="btn-holder">
                        <div className="add-btn">
                            <Button lg gray type="button" onClick={addFeilds}>
                                <FaPlus />
                                Add Variation
                            </Button>
                        </div>
                        <div className="save-btn">
                            <Button lg type="submit">
                                Save Variation
                            </Button>
                        </div>
                    </div>
                </Form>
            </NewVariationWrap>
        </>
    );
};


export default AddVariation;
